import { createAsyncAction } from 'async-selector-kit'
import { API_PATH_UPDATE_PAYMENT } from '../../../../config'
import { RootState } from '../../../../store'
import { ApiConfig, getLocalServerURL } from '../../../../utils/getApiConfig'
import { onIsLoading } from '../../../../utils/onLoading'
import { getPortalBootstrapForce } from '../../selectors/api/bootstrap'
import { onError } from '../../../../utils/onError'

export type StoreLike = {
  getState: () => RootState
  dispatch: (action: unknown) => void
}

/**
 * Core payment update logic. Exported for testing (success, error).
 */
export async function executeUpdatePayment(
  store: StoreLike,
  config: ApiConfig
): Promise<void> {
  const PATH = getLocalServerURL(API_PATH_UPDATE_PAYMENT)
  onIsLoading(true)
  try {
    const response = await fetch(PATH, config)
    if (!response.ok) {
      onError('Failed to update payment')
      return
    }
    const data = await response.json()
    if (data?.messages?.resultCode === 'Ok') {
      setTimeout(async () => {
        await getPortalBootstrapForce(store.getState() as RootState)
      }, 2000)
    } else {
      const error = data?.messages?.message?.[0]?.text || 'Unknown error'
      onError(error)
    }
  } finally {
    onIsLoading(false)
  }
}

export const [updatePaymnet, _, updatePaymnetError] = createAsyncAction(
  {
    id: 'update-payment',
    async: (store) => async (config: ApiConfig) => {
      await executeUpdatePayment(store, config)
    },
  },
  []
)
